module.exports = __webpack_public_path__ + "images/7ceb91f4407264ac2243d61b19ff8984-ab-mapGrey.png";